export default {
  bind (el, binding) {
    if (binding.value !== 'static') {
      binding.def.methods.init(el)
    }
  },

  unbind (el, binding) {
    if (binding.value !== 'static') {
      binding.def.methods.unbindEvents()
    }
  },

  methods: {
    init (el) {
      this.bindEvents(el)
      this.scroll(el)
    },

    bindEvents (el) {
      window.addEventListener('scroll', () => this.scroll(el))
    },

    unbindEvents () {
      window.removeEventListener('scroll', this.scroll)
    },

    scroll (el) {
      if (window.pageYOffset >= el.offsetHeight) {
        el.classList.add('is-sticked')
      } else {
        el.classList.remove('is-sticked')
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/directives/sticky-navbar.js